/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function Delete({ width = 14.222, height = 16, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14.222 16"
      {...props}
    >
      <path
        id="delete_FILL0_wght400_GRAD0_opsz24"
        d="M6.667,19a1.783,1.783,0,0,1-1.778-1.778V5.667H4V3.889H8.444V3h5.333v.889h4.444V5.667h-.889V17.222A1.781,1.781,0,0,1,15.556,19ZM15.556,5.667H6.667V17.222h8.889ZM8.444,15.444h1.778v-8H8.444Zm3.556,0h1.778v-8H12ZM6.667,5.667v0Z"
        transform="translate(-4 -3)"
        fill="#8c8c8c"
      />
    </svg>
  );
}
export default Delete;
